const styles = () => ({
  root: {
    flex: '1 1 auto',
    display: 'flex',
    alignItems: 'stretch',
    height: '100%',
    overflow: 'hidden',
  },

  background: {
    position: 'absolute',
    top: 200,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: -1,
  },

  lhc: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    borderRight: '1px solid #f6f7fa',
  },

  rhc: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '75px',
  },

  spacer: {
    flex: '1 1 auto',
  },

  header: {
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    padding: '34px 50px 10px 0',
  },
});

export default styles;
